<template>
  <corner-ribbon :class="isCarousel ? 'bg-orange carousel-corner-ribbon' : 'bg-orange corner-ribbon'">
    SOLD
  </corner-ribbon>
</template>

<script>
import CornerRibbon from "./CornerRibbon.vue";

export default {
  components: {
    CornerRibbon
  },

  props: {
    isCarousel: {
      type: Boolean,
      default: false,
    }
  }
}
</script>
